(function () {
  var root = document.querySelector('[data-vg-article]');
  if (!root) return;
 
  var KEY = 'vg_blog_favs'; // shared with the blog listing hearts
 
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function setFavs(favs) {
    try { localStorage.setItem(KEY, JSON.stringify(favs)); } catch (e) {}
  }
 
  var articleId = root.getAttribute('data-article-id');
 
  // ---- Favorite ----
  var favBtn = root.querySelector('[data-fav-btn]');
  function renderFav() {
    if (!favBtn) return;
    var isFav = getFavs().indexOf(articleId) !== -1;
    favBtn.classList.toggle('is-fav', isFav);
    favBtn.setAttribute('aria-pressed', String(isFav));
    var label = favBtn.querySelector('[data-fav-label]');
    if (label) label.textContent = isFav ? 'Saved' : 'Save';
  }
  if (favBtn) {
    favBtn.addEventListener('click', function () {
      var favs = getFavs();
      var i = favs.indexOf(articleId);
      if (i === -1) { favs.push(articleId); } else { favs.splice(i, 1); }
      setFavs(favs);
      renderFav();
    });
    renderFav();
  }
 
  // ---- Copy link ----
  var copyBtn = root.querySelector('[data-copy-btn]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var url = copyBtn.getAttribute('data-url') || window.location.href;
      var done = function () {
        copyBtn.classList.add('is-copied');
        var label = copyBtn.querySelector('[data-copy-label]');
        var orig = label ? label.textContent : '';
        if (label) label.textContent = 'URL copied';
        setTimeout(function () {
          copyBtn.classList.remove('is-copied');
          if (label) label.textContent = orig;
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          window.prompt('Copy link:', url);
        });
      } else {
        window.prompt('Copy link:', url);
      }
    });
  }
 
  // ---- Native share (copy fallback) ----
  var shareBtn = root.querySelector('[data-share-btn]');
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = shareBtn.getAttribute('data-url') || window.location.href;
      var title = shareBtn.getAttribute('data-share-title') || document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url);
      } else {
        window.prompt('Copy link:', url);
      }
    });
  }
 
  // ---- Convert imported "\u25cf" pseudo-bullets into real compact lists ----
  // Importer wrote literal bullet chars inside <p> tags; real <ul><li> markup
  // renders denser and gives search engines proper list structure.
  var contentEl = root.querySelector('[data-vg-content]');
  if (contentEl) {
    var BULLET = '\u25cf';
    var cleanPart = function (s) {
      return s.replace(/^(?:\s|&nbsp;|<br\s*\/?\s*>)+/gi, '').replace(/(?:\s|&nbsp;|<br\s*\/?\s*>)+$/gi, '');
    };
    contentEl.querySelectorAll('p').forEach(function (p) {
      if (p.innerHTML.indexOf(BULLET) === -1) return;
      var parts = p.innerHTML.split(BULLET);
      var intro = cleanPart(parts.shift());
      var items = parts.map(cleanPart).filter(function (x) { return x !== ''; });
      if (!items.length) return;
      var ul = document.createElement('ul');
      ul.className = 'vg-bullets';
      items.forEach(function (it) {
        var li = document.createElement('li');
        li.innerHTML = it;
        ul.appendChild(li);
      });
      if (intro) {
        p.innerHTML = intro;
        p.insertAdjacentElement('afterend', ul);
      } else {
        p.replaceWith(ul);
      }
    });
  }
 
  // ---- Auto table of contents (from H2s, shown when 3+) ----
  var content = root.querySelector('[data-vg-content]');
  var toc = root.querySelector('[data-vg-toc]');
  var tocList = root.querySelector('[data-vg-toc-list]');
  if (content && toc && tocList) {
    var heads = content.querySelectorAll('h2');
    if (heads.length >= 3) {
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        tocList.appendChild(li);
      });
      toc.hidden = false;
      tocList.addEventListener('click', function (e) {
        var link = e.target.closest('a');
        if (!link) return;
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', link.getAttribute('href'));
        }
      });
    }
  }
 
  // ---- Reading progress bar ----
  var bar = root.querySelector('[data-vg-progress]');
  if (bar && content) {
    var onScroll = function () {
      var rect = content.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      if (total <= 0) { bar.style.width = '100%'; return; }
      var done = Math.min(Math.max(-rect.top, 0), total);
      bar.style.width = ((done / total) * 100) + '%';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }
 
  // ---- Shop-this-article carousel arrows ----
  var carousel = root.querySelector('[data-vg-carousel]');
  if (carousel) {
    var track = carousel.querySelector('[data-vg-car-track]');
    var prev = carousel.querySelector('[data-vg-car-prev]');
    var next = carousel.querySelector('[data-vg-car-next]');
    if (track && prev && next) {
      var step = function () { return Math.max(track.clientWidth * 0.8, 200); };
      var update = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        var scrollable = max > 4;
        prev.hidden = !scrollable || track.scrollLeft <= 2;
        next.hidden = !scrollable || track.scrollLeft >= max;
      };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }
  }
})();







